import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { ToastContext, Card, Button, TextArea, StandardHeader } from '@weezevent/nacre';
import Styles from './ticketInfoDrawer.module.css';
import { default as SideBar } from './portal';

function TicketDataCard({ ticket = {}, onCopy = () => {}, formated_data = '' }) {
    const { t } = useTranslation();

    return (
        <Card className={Styles['card-data']}>
            <Card.Header>
                <Card.Title title={t('ticket.webservice.ticket-list.modal.title')} />
            </Card.Header>
            <Card.Content className={Styles['content-card']}>
                <TextArea disabled value={formated_data} style={{ resize: 'none' }} />
                <Button primary onClick={onCopy}>
                    {t('ticket.webservice.ticket-list.modal.copy')}
                </Button>
            </Card.Content>
        </Card>
    );
}

TicketDataCard.propTypes = {
    ticket: PropTypes.object.isRequired,
    onCopy: PropTypes.func.isRequired,
    formated_data: PropTypes.string.isRequired
};

function TicketHistoryCard({ ticket = {} }) {
    const { t } = useTranslation();

    const formatDate = date =>
        new Date(date).toLocaleString('fr-FR', {
            dateStyle: 'short',
            timeStyle: 'short'
        });

    return (
        <Card className={Styles['card-data']}>
            <Card.Header>
                <Card.Title title={t('ticket.common.history')} />
            </Card.Header>
            <Card.Content>
                {(!ticket.ticket_history || ticket.ticket_history.length === 0) && <p>{t('ticket.webservice.ticket-list.history.noHistory')}</p>}
                {ticket.ticket_history?.map((history, idx) => {
                    if (history.pushed_at) {
                        return (
                            <div key={idx} className={Styles['history-item']}>
                                {t('ticket.webservice.ticket-list.history.receivedAt', {
                                    date: formatDate(history.pushed_at)
                                })}
                            </div>
                        );
                    }

                    if (history.pushed_to_weez_at) {
                        return (
                            <div key={idx} className={Styles['history-item']}>
                                {t('ticket.webservice.ticket-list.history.pushedToWeez', {
                                    date: formatDate(history.pushed_to_weez_at)
                                })}
                            </div>
                        );
                    }
                    return null;
                })}
            </Card.Content>
        </Card>
    );
}

TicketHistoryCard.propTypes = {
    ticket: PropTypes.object.isRequired
};

function DrawerContent({ ticket = {}, formated_data = '', onCopy = () => {} }) {
    return (
        <div>
            <TicketDataCard ticket={ticket} onCopy={onCopy} formated_data={formated_data} />
            <TicketHistoryCard ticket={ticket} />
        </div>
    );
}

DrawerContent.propTypes = {
    ticket: PropTypes.object.isRequired,
    formated_data: PropTypes.string.isRequired,
    onCopy: PropTypes.func.isRequired
};

export function TicketInfoDrawer({ ticket = {}, openSideBar = false, onCloseSideBar = () => {} }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const formated_data = React.useMemo(() => JSON.stringify(ticket?.data, undefined, 4), [ticket]);

    const onCopy = React.useCallback(() => {
        navigator.clipboard.writeText(formated_data);
        toast.success(t('ticket.webservice.ticket-list.modal.toast-success'));
    }, [formated_data, toast]);

    if (!ticket) {
        return null;
    }

    return (
        <SideBar className={Styles['drawer']} open={openSideBar} onClickAway={onCloseSideBar} onClose={onCloseSideBar} size="medium">
            <StandardHeader title={ticket.ticket_identifier} />
            <DrawerContent ticket={ticket} onCopy={onCopy} formated_data={formated_data} />
        </SideBar>
    );
}

TicketInfoDrawer.propTypes = {
    ticket: PropTypes.object,
    openSideBar: PropTypes.bool,
    onCloseSideBar: PropTypes.func
};
